import {
  Box,
  Typography,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

const sectionHeaderStyle = {
  color: '#84d8c5',
  fontWeight: 700,
  mb: 3,
};

const boxInfoStyle = {
  bgcolor: '#3A4152',
  width: 1,
  p: 1,
  px: 2,
  borderRadius: 1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

// to remove later when turning each thing into a component
const detailsStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 1,
  display: 'inline-block',
  cursor: 'default',
  minHeight: 24,
};

// The disabled prop also greys out the checkbox labels
// this restores the label color so the text is not greyed out.
const readOnlyControlStyle = {
  '& .MuiFormControlLabel-label.Mui-disabled': {
    color: 'text.primary',
  },
};

export const EmployeeHistoryComponent = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <Box
        sx={{
          padding: '20px',
        }}
      >
        <Typography variant="h5" sx={sectionHeaderStyle}>
          Criminal Background
        </Typography>
        <Box
          sx={{
            marginBottom: '17px',
          }}
        >
          <FormControlLabel
            disabled
            sx={readOnlyControlStyle}
            control={<Checkbox checked={!!props.empHistory?.formallycharged} />}
            label="Have you ever been formally charged?"
          />
          <Grid>
            <Box sx={boxInfoStyle}>
              <Typography
                variant="body1"
                sx={{
                  ...detailsStyle,
                }}
              >
                {props.empHistory?.chargedetails}
              </Typography>
            </Box>
          </Grid>
        </Box>

        <Box
          sx={{
            marginBottom: '17px',
          }}
        >
          <FormControlLabel
            disabled
            sx={readOnlyControlStyle}
            control={<Checkbox checked={!!props.empHistory?.guiltyoffense} />}
            label="Have you ever been guilty of any offense?"
          />
          <Grid>
            <Box sx={boxInfoStyle}>
              <Typography
                variant="body1"
                sx={{
                  ...detailsStyle,
                }}
              >
                {props.empHistory?.offensedetails}
              </Typography>
            </Box>
          </Grid>
        </Box>

        <Box
          sx={{
            marginBottom: '17px',
          }}
        >
          <FormControlLabel
            disabled
            sx={readOnlyControlStyle}
            control={<Checkbox checked={!!props.empHistory?.convicted} />}
            label="Have you ever been convicted of any crime or violation of any law, decree, ordinance or regulation by any court or tribunal?"
          />
          <Grid>
            <Box sx={boxInfoStyle}>
              <Typography
                variant="body1"
                sx={{
                  ...detailsStyle,
                }}
              >
                {props.empHistory?.convictdetails}
              </Typography>
            </Box>
          </Grid>
        </Box>
        <Typography variant="h5" sx={{ ...sectionHeaderStyle, mt: 5 }}>
          Previous employment
        </Typography>
        <Box
          sx={{
            marginBottom: '17px',
          }}
        >
          <FormControlLabel
            disabled
            sx={readOnlyControlStyle}
            control={
              <Checkbox checked={!!props.empHistory?.terminatedemployment} />
            }
            label="Have you ever been separated from the employment/service in any of the following modes:
                  resignation, retirement, dropped from the rolls, dismissal, termination, end of term, finished
                  contract, AWOL or phased out, in the public or private sector?"
          />
          <Grid>
            <Box sx={boxInfoStyle}>
              <Typography
                variant="body1"
                sx={{
                  ...detailsStyle,
                }}
              >
                {props.empHistory?.employmentdetails}
              </Typography>
            </Box>
          </Grid>
        </Box>
        <Typography variant="h5" sx={{ ...sectionHeaderStyle, mt: 5 }}>
          {' '}
          Other Information
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: '17px',
          }}
        >
          Pursuant to: (a) Indigenous People's Act (RA 8371); (b) Magna Carta
          for Disabled Persons (RA 7277); and (c) Solo Parents Welfare Act of
          2000 (RA 8972), please answer the following items:
        </Typography>
        <Box
          sx={{
            marginBottom: '17px',
          }}
        >
          <FormControlLabel
            disabled
            sx={readOnlyControlStyle}
            control={
              <Checkbox checked={!!props.empHistory?.indigenousmember} />
            }
            label="Are you a member of any indigenous group?"
          />
          <Grid>
            <Box sx={boxInfoStyle}>
              <Typography
                variant="body1"
                sx={{
                  ...detailsStyle,
                }}
              >
                {props.empHistory?.indigenousdetails}
              </Typography>
            </Box>
          </Grid>
        </Box>

        <Box
          sx={{
            marginBottom: '17px',
          }}
        >
          <FormControlLabel
            disabled
            sx={readOnlyControlStyle}
            control={<Checkbox checked={!!props.empHistory?.diffabled} />}
            label="Are you differently abled?"
          />
          <Grid>
            <Box sx={boxInfoStyle}>
              <Typography
                variant="body1"
                sx={{
                  ...detailsStyle,
                }}
              >
                {props.empHistory?.diffableddetails}
              </Typography>
            </Box>
          </Grid>
        </Box>

        <Box
          sx={{
            marginBottom: '17px',
          }}
        >
          <FormControlLabel
            disabled
            sx={readOnlyControlStyle}
            control={<Checkbox checked={!!props.empHistory?.soloparent} />}
            label="Are you a solo parent?"
          />
          <Grid>
            <Box sx={boxInfoStyle}>
              <Typography
                variant="body1"
                sx={{
                  ...detailsStyle,
                }}
              >
                {props.empHistory?.soloparentdetails}
              </Typography>
            </Box>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};
